import Query from '../utils/Query';

const defaultFields = '';

export default class DeploymentService {

	static publish(collection, id, version, changelog) {

	}
}
